import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchBlogs as fetcher, blogsActions as actions } from '../../../features/blogs/slice'
import { useViewport } from '../../../utils'
import { MainContent, MainContentMobile } from '.'
import * as pageConfig from '../config'

const PageContent = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const { status, error } = useSelector(state => state.blogs)

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetcher())}
    >
      {
        isDesktop ? (
          <MainContent
            pageConfig={pageConfig}
            actions={actions}
          />
        ) : (
          <MainContentMobile
            pageConfig={pageConfig}
            actions={actions}
          />
        )
      }
    </StatusHandler>
  )
}

export { PageContent }
